import './src/styles/prism.light-theme.scss';
import './src/styles/prism.dark-theme.scss';
import './src/styles/global.scss';
